module.exports = __webpack_public_path__ + "apple-icon-precomposed.png?3399e672470e81db58fa9366758ce401";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-icon-precomposed.png
// module id = 136
// module chunks = 0